var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDanish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "182px",
    viewBox: "0 0 182 182",
    width: "182px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Denmark",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9999943,170.644802 C62.0495853,176.632938 75.6315827,180 90,180 C136.325539,180 174.47627,144.999507 179.450712,100 L179.450712,100 L50,100 L50,170.644805 Z M30,157.083197 C13.9223855,142.693343 3.04855005,122.608679 0.549287698,100 L30,100 L30,157.083197 Z M49.9999943,9.35519833 C62.0495852,3.36706168 75.6315827,0 90,0 C136.325539,0 174.47627,35.0004935 179.450712,80 L179.450712,80 L50,80 L50,9.35519552 Z M30,22.916803 C13.9223855,37.3066571 3.04855005,57.3913208 0.549287698,80 L30,80 L30,22.916803 Z M30,22.916803",
    fill: "#CA4638",
    id: "Oval-1-copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9999927,9.35519916 C42.7189439,12.9735724 35.9974173,17.5489694 30,22.916803 L30,157.083197 C35.9974173,162.451031 42.7189439,167.026428 49.9999927,170.644801 L50,9.35519552 Z M49.9999927,9.35519916",
    fill: "#FFFFFF",
    id: "Oval-1-copy-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.450712,100 C179.813667,96.7166615 180,93.380091 180,90 C180,86.619909 179.813667,83.2833385 179.450712,80 L0.549287698,80 C0.186333089,83.2833385 0,86.619909 0,90 C0,93.380091 0.186333089,96.7166615 0.549287698,100 L179.450712,100 Z M179.450712,100",
    fill: "#FFFFFF",
    id: "Oval-1-copy-6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanish);
export default __webpack_public_path__ + "static/media/danish.6459ca1bc51d9f34e4da74f93904d875.svg";
export { ForwardRef as ReactComponent };